import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-waves-effects',
	templateUrl:'./WavesEffectsPluginCompPage.html',
	styles: [],
	styleUrls:['./WavesEffectsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WavesEffectsPluginCompPage
{
	mdContent_1160 = `\`\`\`java
import com.jwebmp.plugins.waveseffect.WavesEffects;
\`\`\``;
	mdContent_1161 = `\`\`\`java
// Use with WavesApplyToSelectorFeature
new WavesApplyToSelectorFeature(".btn",
    WavesEffects.Waves_Effect,
    WavesEffects.Waves_Light);
\`\`\``;
}
